module.exports = __webpack_public_path__ + "img/bgi2.77944cac.png";